import React from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { getDiffDays } from "utils/datetime";
import { FiCalendar } from "react-icons/fi";
import { MdAttachFile } from "react-icons/md";
import { workflowsService } from "services";

const AbsenceListItemPeriod = ({ absence }) => {
	const { t } = useTranslation();

	let nTime = absence.effective_days || 0;
	if (nTime === 0) nTime = getDiffDays(absence.start, absence.end);

	let unit = t("absences.period.days", { count: nTime });

	if (absence.workflow_hourly_requested) {
		nTime = absence.duration;
		unit = t("absences.period.hours", { count: nTime });
		nTime = nTime.toString().replace(".", ",");
	}

	const getAttachment = async (absence, attachment) => {
		const response = await workflowsService.getAttachment(
			absence.id,
			attachment.url
		);
		var url = window.URL.createObjectURL(response);
		var a = document.createElement("a");
		document.body.appendChild(a);
		a.href = url;
		a.download = attachment.name;
		a.click();
	};

	const attachments =
		absence.attachments &&
		absence.attachments.map((attachment) => {
			var size = attachment.size / 1000000;
			var sizeLetters = "Mb";

			if (size < 1) {
				size = attachment.size / 1000;
				sizeLetters = "Kb";
			}

			return (
				<li className="file-item" key={attachment.url}>
					<span
						className="file-info"
						title={attachment.name}
						onClick={() => getAttachment(absence, attachment)}
					>
						<span className="file-name">{attachment.name}</span>
						<span className="file-size">
							({size.toFixed(2)}
							{sizeLetters})
						</span>
					</span>
				</li>
			);
		});

	return (
		<>
			<div className="form-group no-form">
				<h4 className="ausencia-tipo">{absence.shift_type}</h4>
				<p className="ausencia-resumen">
					{t("absences.period.request", { count: nTime, unit })}
				</p>
			</div>

			<div className="form-group no-form form-group-period flex-between align-items-start">
				<div>
					<FiCalendar />
					<span>
						<span className="tag-dia">
							{new Date(absence.start).toLocaleDateString(i18next.language || "es-ES", { day: "numeric", month: "short" })}
						</span>
						{absence.end && (
							<span className="tag-dia">
								{new Date(absence.end).toLocaleDateString(i18next.language || "es-ES", { day: "numeric", month: "short" })}
							</span>
						)}
					</span>
				</div>
				{absence.attachments && absence.attachments.length > 0 && (
					<div className="ausencia-attachments">
						<MdAttachFile
							title={t("absences.period.hasAttachments")}
							className="absence-attachment"
						/>
						<ul className="dropzone-files">{attachments}</ul>
					</div>
				)}
			</div>
		</>
	);
};

export default AbsenceListItemPeriod;
